import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { LoginCommercialFormSchema, LoginCommercialMutation } from './LoginCommercialForm.types';
import { getLoginCommercialForm } from './LoginCommercialForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { loginCommercialFormData } from './LoginCommercialForm.data';
import { useNavigate } from 'react-router-dom';
import Form from '../../../../commons/Form/Form';
import { LOGIN_COMMERCIAL_QUERY_KEY, loginCommercialQuery } from './LoginCommercialForm.query';
import { setProfile } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import { User, UserRoles } from '../../../../../types/models/user/user.types';
import { useDispatch } from 'react-redux';
import { api } from '../../../../../utils/api/api';
import { useCookies } from 'react-cookie';
import moment from 'moment';

export default () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie] = useCookies(['token']);

  const formProps = useForm<LoginCommercialFormSchema>({
    resolver: yupResolver(getLoginCommercialForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<
    Awaited<ReturnType<LoginCommercialMutation>>,
    Error,
    LoginCommercialFormSchema
  >((data) => loginCommercialQuery(data), {
    mutationKey: LOGIN_COMMERCIAL_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: ({ commercial, accessToken }) => {
      // @ts-ignore
      setProfile({ ...(commercial as User), role: UserRoles.Commercial })(dispatch);
      api.setHeader('authorization', `Bearer ${accessToken}`);
      setCookie('token', accessToken, { expires: moment().add(60, 'minutes').toDate(), path: '/' });
      navigate('/dashboard');
    },
    onError: (error) => alert(error.message),
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<LoginCommercialFormSchema>
        data={loginCommercialFormData}
        style={{
          width: 400,
          alignSelf: 'center',
        }}
        {...{ formProps, onSubmit }}
      />
    </>
  );
};
